import { render } from "./ProgressCol.vue?vue&type=template&id=48984bb2"
import script from "./ProgressCol.vue?vue&type=script&lang=js"
export * from "./ProgressCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__